<div class="row" *ngIf="isFullscreen">
    <div class="fullscreen-header-container container-fluid">
        <div class="title col-6">{{ dashboardService.getActiveCXoneDashboard()?.dashboard?.DashboardName }}</div>
        <div class="col-6 d-flex justify-content-end">
            <button type="button" class="icon-btn minimize-header" (click)="toggleFullscreen()">
                <svg class="icon-12 fill-iconDefault">
                    <use href="../App_Themes/CXone/icons/close.svg#close"></use>
                </svg>
            </button>
        </div>
    </div>
</div>

<div class="row" *ngIf="!isFullscreen">
    <div *ngIf="!isAddingWidgets" [ngClass]="dashboardService.getActiveCXoneDashboard() ? 'header-container' : 'empty-header-container'">
        <!-- Select Dashboard -->
        <div class="select-dashboard-container mr-auto">
            <cxone-singleselect-dropdown class="cxone-dropdown"
                                         [(ngModel)]="selectedDashboard"
                                         [placeholder]="selectDashboardText"
                                         [options]="availableCxoneListDashboards"
                                         [label]="'DashboardName'"
                                         [primaryKey]="'DashboardKey'"
                                         [isLoading]="dashboardService.dashboardsLoading"
                                         [isRequired]="false"
                                         [sortOrder]="'none'"
                                         [showFooter]="false"
                                         (ngModelChange)="selectDashboard($event, dashboardService.workspaceKey)"
                                         [template]="dropdownTemplate"
                                         [templateSelection]="dropdownTemplateSelection"
                                         [maxItemsToDisplay]="1000"
                                         data-qa="cxone-dashboard-header-select-dashboard-dropdown">
            </cxone-singleselect-dropdown>
            <ng-template #dropdownTemplateSelection let-item="item" let-query>
                <div class="custom-item d-flex">
                    <svg [ngClass]="item.IsFavorite ? 'fill-star' : 'fill-iconDefault-noHover'" class="mr-2 flex-grow-0 flex-shrink-0" style="height: 16px; width: 16px;">
                        <use [attr.href]="item.IsFavorite ? filledStarUrl : unfilledStarUrl"></use>
                    </svg>
                    <span class="text-truncate" [textContent]="item.DashboardName"></span>
                </div>
            </ng-template>
            <ng-template #dropdownTemplate let-item let-query>
                <div class="custom-item item-layout">
                    <div class="d-flex">
                        <svg [ngClass]="item.IsFavorite ? 'fill-star' : 'fill-iconDefault-noHover'" class="mr-2 flex-grow-0 flex-shrink-0" style="height: 16px; width: 16px; ">
                            <use [attr.href]="item.IsFavorite ? filledStarUrl : unfilledStarUrl"></use>
                        </svg>
                        <span class="name text-truncate" [textContent]="item.DashboardName"></span>
                    </div>
                    <div class="d-flex">
                        <div class="mr-2 flex-grow-0 flex-shrink-0" style="height: 16px; width: 16px;"></div>
                        <span class="description text-truncate" [textContent]="item.DashboardDescription"></span>
                    </div>
                </div>
            </ng-template>
        </div>

        <div id="headerButtonsContainer" class="headerButtonsContainer ml-3" *ngIf="dashboardService?.getActiveCXoneDashboard() !== null">
            <!-- Add Dashboard Filter
            <button *ngIf="canFilter(dashboardService.getActiveCXoneDashboard())" id="addFilterButton" type="button" [ngClass]="!filtersApplied ? 'icon-btn header-btn-sm' : 'header-btn filter-btn'" (click)="toggleAddFilter()">
                <svg class="icon-20"><use href="../App_Themes/CXone/icons/filter-alt.svg#filter-alt"></use></svg>
                <div [hidden]="!filtersApplied">
                    <span>    
                        <span runat="server" style="padding-right: 10px" cvLocalizedText [langSection]="'Dashboard_Filter'" [langKey]="'Filter_Applied'">Filter Applied  </span> 
                        <span class="circle">{{filtersApplied}}</span>
                    </span>
                </div>
            </button> -->
            <!-- Add Widget -->
            <button id="addWidgetButton" type="button" class="btn header-btn add-widget-btn" (click)="toggleAddWidget()" *ngIf="canAddWidget(dashboardService.getActiveCXoneDashboard()) && !dashboardService.dashboardsLoading">
                <svg><use href="../App_Themes/CXone/icons/add.svg#add"></use></svg>
                <span class="headerText" runat="server" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Add_Widget'" navigation-sidebar-localized-tooltip cv-non-breaking-spaces>Add Widget</span>
            </button>
            <!-- Export -->
            <div class="sub-menu-button" *ngIf="canExport(dashboardService.getActiveCXoneDashboard())">
                <button id="headerExport" type="button" class="btn header-btn" (click)="export(dashboardService.getActiveCXoneDashboard(), excel)" [disabled]="disableExport">
                    <svg>
                        <use href="../App_Themes/CXone/icons/export.svg#export"></use>
                    </svg>
                    <span cvLocalizedText [langSection]="'Module_Menu'" [langKey]="'Export'">Export</span>
                </button>
            </div>
            <!-- Subscription button that will show if there is a not a current subscription -->
            <button type="button" id="subscriptionButton" class="btn header-btn" *ngIf="canSubscribe(dashboardService.getActiveCXoneDashboard()) && !checkSubscription()" (click)="cxoneSubscription()">
                <svg>
                    <use href="../App_Themes/CXone/icons/email.svg#email"></use>
                </svg>
                <span class="headerText" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Subscription'">Subscription</span>
            </button>
            <!-- Subscripton button that will show if there is a current subscription -->
            <button mat-button [matMenuTriggerFor]="subscriptionMenu" type="button" class="btn header-btn" *ngIf="canSubscribe(dashboardService.getActiveCXoneDashboard()) && checkSubscription()">
                <svg>
                    <use href="../App_Themes/CXone/icons/email.svg#email"></use>
                </svg>
                <span class="headerText" cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Subscription'">Subscription</span>
                <svg class="ml-2" style="width: 12px; height: 12px; margin-right: 0px;">
                    <use href="../App_Themes/CXone/icons/arrow.svg#arrow"></use>
                </svg>
            </button>
            <mat-menu #subscriptionMenu="matMenu" xPosition="after">
                <button mat-menu-item cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Delete_Subscription'" (click)="deleteSubscription()">Delete Subscription</button>
                <button mat-menu-item cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Edit_Subscription'" (click)="cxoneSubscription()">Edit Subscription</button>
            </mat-menu>
            <!-- Share -->
            <button type="button" id="headerShareButton" class="btn header-btn share-btn" *ngIf="canShare(dashboardService.getActiveCXoneDashboard()) && !dashboardService.dashboardsLoading"
                    (click)="cxoneShare(dashboardService.getActiveCXoneDashboard())">
                <svg>
                    <use href="../App_Themes/CXone/icons/share.svg#share"></use>
                </svg>
                <span class="headerText" cvLocalizedText [langSection]="'Common'" [langKey]="'Share'">Share</span>
            </button>
            <!-- FullScreen Toggle -->
            <div id="headerFullscreenToggle" class="fullscreen-toggle">
                <button type="button" class="icon-btn header-btn-sm" [hidden]="isFullscreen" (click)="toggleFullscreen()">
                    <svg class="icon-20">
                        <use href="../App_Themes/CXone/icons/expand.svg#expand"></use>
                    </svg>
                </button>
                <button type="button" class="icon-btn header-btn" [hidden]="!isFullscreen" (click)="toggleFullscreen()">
                    <svg class="mx-auto">
                        <use href="../App_Themes/clearview-default/icons/utility/shrink.svg#shrink"></use>
                    </svg>
                </button>
            </div>
            <!-- Options/More -->
            <div id="optionsMenu" ngbDropdown #dropdown="ngbDropdown" autoClose="outside" *ngIf="hasCreatePermission() || canSetTimezone(dashboardService.getActiveCXoneDashboard())">
                <button id="headerOptionsButton" type="button" class="icon-btn no-dropdown-caret header-btn-sm pl-2" ngbDropdownToggle>
                    <svg class="mx-auto">
                        <use href="../App_Themes/CXone/icons/dropdown.svg#dropdown"></use>
                    </svg>
                </button>
                <ul id="headerOptionsList" class="dropdown-menu cxoneHeaderMenu dropdown-submenu header-dropdown" ngbDropdownMenu>
                    <div class="arrow"></div>
                    <!-- Edit -->
                    <li *ngIf="canEdit(dashboardService.getActiveCXoneDashboard())" ngbDropdownItem>
                        <button id="editDetailsButton" type="button" class="btn dropdown-menu-item"
                                (click)="editDashboard(dashboardService.getActiveCXoneDashboard()); dropdown.close();">
                            <svg class="icon-18 dropdown-menu-icon">
                                <use href="../App_Themes/CXone/icons/edit.svg#edit"></use>
                            </svg>
                            <span cvLocalizedText [langSection]="'Dashboard_Tab'" [langKey]="'Edit_Details'">Edit Details</span>
                        </button>
                    </li>
                    <!-- Duplicate -->
                    <div [ngbPopover]="publishPending ? saveOrCancelTooltip : ''" triggers="mouseenter:mouseleave" placement="left" container="body" 
                        popoverClass="headerMenuTooltip">
                        <li *ngIf="hasCreatePermission()" ngbDropdownItem [disabled]="publishPending" >
                            <button id="duplicateDashboardButton" type="button" class="btn dropdown-menu-item" 
                                (click)="duplicateDashboard(dashboardService.getActiveCXoneDashboard(), dashboardService.workspaceKey); dropdown.close();">
                                <svg class="icon-18 dropdown-menu-icon">
                                    <use href="../App_Themes/CXone/icons/duplicate.svg#duplicate"></use>
                                </svg>
                                <span cvLocalizedText [langSection]="'CXOne_Dashboard'" [langKey]="'Duplicate'">Duplicate</span>
                            </button>
                        </li>
                    </div>
                    <!-- Delete -->
                    <li *ngIf="canDelete(dashboardService.getActiveCXoneDashboard())" ngbDropdownItem>
                        <!-- Delete modal-->
                        <ng-template #deleteModal let-modal>
                            <div>
                                <div class="popoverText popoverSpacingTop" cvLocalizedText langSection="Dashboards_Landing" langKey="Dashboard_Delete_Warning">
                                    You are about to delete this dashboard.
                                </div>
                                <div class="popoverText" cvLocalizedText langSection="Dashboards_Landing" langKey="Revert_Warning">
                                    This action cannot be undone.
                                </div>
                                <div class="popoverText popoverSpacingBottom" cvLocalizedText langSection="Dashboards_Landing" langKey="Continue">
                                    Continue?
                                </div>
                                <div class="confirmBtns">
                                    <button type="button" class="cxone-btn btn-medium btn-popover" style="margin-right: 10px;">
                                        <span cvLocalizedText langSection="Common" langKey="No">No</span>
                                    </button>
                                    <button type="button" (click)="deleteDashboard(dashboardService.getActiveCXoneDashboard());" class="cxone-btn btn-medium btn-primary">
                                        <span cvLocalizedText langSection="Common" langKey="Yes">Yes</span>
                                    </button>
                                </div>
                            </div>
                        </ng-template>
                        <button id="deleteButton" type="button" class="btn dropdown-menu-item" [ngbPopover]="deleteModal" popoverClass="cxoneConfirmDashboardDeletePopover"
                                triggers="click" container="body" placement="bottom-right">
                            <svg class="icon-18 dropdown-menu-icon">
                                <use href="../App_Themes/CXone/icons/delete.svg#delete"></use>
                            </svg>
                            <span cvLocalizedText langSection="Common" langKey="Delete">Delete</span>
                        </button>
                    </li>
                    <!-- Time Zone -->
                    <li class="sub-menu-button" *ngIf="canSetTimezone(dashboardService.getActiveCXoneDashboard())" ngbDropdownItem>
                        <button id="timeZoneButton" type="button" class="btn dropdown-menu-item">
                            <svg class="icon-18 dropdown-menu-icon">
                                <use href="../App_Themes/CXone/icons/timezone.svg#timezone"></use>
                            </svg>
                            <span cvLocalizedText [langSection]="'Time_Zone'" [langKey]="'Time_Zone'">Time Zone</span>
                            <svg class="icon-12 dropdown-menu-icon arrow-margin">
                                <use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right"></use>
                            </svg>
                        </button>
                        <ul id="dashboardTimeZoneOptions" class="dropdown-menu dropdown-submenu menu-dropdown">
                            <li [ngClass]="{'selectedLanguage':!dashboardService.getActiveCXoneDashboard()?.dashboard?.TimeZoneInfoName}">
                                <button id="timeZoneOption-Default" type="button" class="btn dropdown-menu-item dropdown-menu-subItem two-words"
                                    (click)="setTimezone(dashboardService.getActiveCXoneDashboard()); dropdown.close();" 
                                    title="{{showSelectedTimeZone(timezoneService.dataObj?.selectedTimeZone)}}">
                                    <span>{{showSelectedTimeZone(timezoneService.dataObj?.selectedTimeZone)}}</span>
                                </button>
                            </li>
                            <li *ngFor="let timezone of timezoneService.filterDataObj?.availableTimeZones" [ngClass]="{'selectedLanguage': dashboardService.getActiveCXoneDashboard()?.dashboard?.TimeZoneInfoName === timezone}">
                                <button [attr.id]="'timeZoneOption-' + timezone" type="button" class="btn dropdown-menu-item dropdown-menu-subItem"
                                        (click)="setTimezone(dashboardService.getActiveCXoneDashboard(), timezone); dropdown.close();">
                                    <span cvLocalizedText [langSection]="'TimeZoneInfo'" [langKey]="timezone">{{timezone}}</span>
                                </button>
                            </li>
                        </ul>
                    </li>
                    <div class="dropdown-divider" *ngIf="hasCreatePermission()"></div>
                    <!-- New Dashboard -->
                    <li class="dropdown-item sub-menu-button" *ngIf="hasCreatePermission()" ngbDropdownItem>
                        <button id="createDashboardButton" type="button" class="btn dropdown-menu-item">
                            <svg class="icon-18 dropdown-menu-icon"><use href="../App_Themes/clearview-default/icons/utility/add.svg#add"></use></svg>
                            <span cvLocalizedText langSection="Dashboards_Landing" langKey="Create_Dashboard">Create Dashboard</span>
                            <svg class="icon-12 dropdown-menu-icon arrow-margin">
                                <use href="../App_Themes/CXone/icons/arrow-right.svg#arrow-right"></use>
                            </svg>
                        </button>
                        <ul id="createDashboardOptions" class="dropdown-menu dropdown-submenu menu-dropdown">
                            <div [ngbPopover]="publishPending ? saveOrCancelTooltip : ''" triggers="mouseenter:mouseleave" placement="left" container="body" 
                                popoverClass="headerMenuTooltip">
                                <li ngbDropdownItem [disabled]="publishPending">
                                    <button id="newButton" type="button" class="btn dropdown-menu-item dropdown-menu-subItem" (click)="createNewDashboard(dashboardService.workspaceKey); dropdown.close();">
                                        <span runat="server" cvLocalizedText langSection="Dashboards_Landing" langKey="New" 
                                            navigation-sidebar-localized-tooltip cv-non-breaking-spaces>New</span>
                                    </button>
                                </li>
                            </div>
                            <div [ngbPopover]="publishPending ? saveOrCancelTooltip : ''" triggers="mouseenter:mouseleave" placement="left" container="body" 
                                popoverClass="headerMenuTooltip">
                            <li ngbDropdownItem [disabled]="publishPending">
                                <button id="fromTemplateButton" type="button" class="btn dropdown-menu-item dropdown-menu-subItem" (click)="openFromTemplate(); dropdown.close();">
                                    <span runat="server" cvLocalizedText langSection="Dashboards_Landing" langKey="From_Template" 
                                    navigation-sidebar-localized-tooltip cv-non-breaking-spaces>From Template</span>
                                </button>
                            </li>
                            </div>
                        </ul>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>

<!-- Add Dashboard Filter 
<div *ngIf="navigationService.isResponsiveDashboard" [ngStyle]="{ 'display': isFilterOpen ? 'block' : 'none' }">
    <cv-cxone-dashboard-filter    
        (closeAddFilter)="toggleAddFilter()"
        [selectedFilters]="selectedFilters"
        (applySelectedFilters)="applyFilters($event)"
        (updateFilterText)="updateFilterAppliedText($event)"
        (isApplyButtonEnabled)="setFiltersApplyButtonState($event)"
        [applyDashboardFiltersReversion]="applyDashboardFiltersReversion">
    </cv-cxone-dashboard-filter>
</div> -->

    <!-- Add Module -->
<div *ngIf="navigationService.isResponsiveDashboard && isAddingWidgets" style="height: 205px">
    <cv-cxone-add-widget *ngIf="navigationService.isResponsiveDashboard && isAddingWidgets" (closeAddWidget)="toggleAddWidget()"></cv-cxone-add-widget>
</div>

